import { render, staticRenderFns } from "./PreparedSentRequests.vue?vue&type=template&id=181b275c&scoped=true&"
import script from "./PreparedSentRequests.vue?vue&type=script&lang=js&"
export * from "./PreparedSentRequests.vue?vue&type=script&lang=js&"
import style0 from "./PreparedSentRequests.vue?vue&type=style&index=0&id=181b275c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b275c",
  null
  
)

export default component.exports